// import React, { useState, useEffect } from "react";
// import { Button, Container, Paper, Typography, Box } from "@mui/material";

// const IndexedDBManager = () => {
//   const [dbExists, setDbExists] = useState(false);
//   const [topRow, setTopRow] = useState(null);

//   const initDB = () => {
//     return new Promise((resolve, reject) => {
//       const request = indexedDB.open("hlthtekdb", 1);

//       request.onupgradeneeded = (event) => {
//         const db = event.target.result;
//         if (!db.objectStoreNames.contains("t_org_key")) {
//           db.createObjectStore("t_org_key", { keyPath: "id", autoIncrement: true });
//         }
//       };

//       request.onsuccess = () => resolve(request.result);
//       request.onerror = () => reject(request.error);
//     });
//   };

//   const checkDBExists = async () => {
//     const databases = await indexedDB.databases();
//     const exists = databases.some((db) => db.name === "hlthtekdb");
//     setDbExists(exists);
//   };

//   const upgradeDB = (newVersion) => {
//     return new Promise((resolve, reject) => {
//       const request = indexedDB.open("hlthtekdb", newVersion);

//       request.onupgradeneeded = (event) => {
//         const db = event.target.result;
//         if (!db.objectStoreNames.contains("t_org_key")) {
//           db.createObjectStore("t_org_key", { keyPath: "id", autoIncrement: true });
//         }
//       };

//       request.onsuccess = () => resolve(request.result);
//       request.onerror = () => reject(request.error);
//     });
//   };

//   const createTable = async () => {
//     const db = await initDB();
//     const transaction = db.transaction("t_org_key", "readwrite");
//     const store = transaction.objectStore("t_org_key");

//     const sampleData = { name: "ORG_CODE", value: "12345" };
//     store.add(sampleData);
//   };

//   const getTopRow = async () => {
//     const db = await initDB();
//     const transaction = db.transaction("t_org_key", "readonly");
//     const store = transaction.objectStore("t_org_key");

//     return new Promise((resolve, reject) => {
//       const request = store.openCursor();
//       request.onsuccess = (event) => {
//         const cursor = event.target.result;
//         setTopRow(cursor ? cursor.value : null);
//         resolve(cursor ? cursor.value : null);
//       };
//       request.onerror = () => reject(request.error);
//     });
//   };

//   useEffect(() => {
//     checkDBExists();
//   }, []);

//   return (
//     <Container maxWidth="sm">
//       <Paper elevation={3} sx={{ padding: 3, textAlign: "center", marginTop: 5 }}>
//         <Typography variant="h5" gutterBottom>
//           IndexedDB Manager
//         </Typography>
//         <Typography variant="body1">
//           Database Exists: <strong>{dbExists ? "Yes" : "No"}</strong>
//         </Typography>
//         <Typography variant="body1">
//           Top Row: {topRow ? JSON.stringify(topRow) : "No Data"}
//         </Typography>
//         <Box mt={2} display="flex" flexDirection="column" gap={2}>
//           <Button variant="contained" color="primary" onClick={initDB}>
//             Initialize DB
//           </Button>
//           <Button variant="contained" color="secondary" onClick={checkDBExists}>
//             Check DB
//           </Button>
//           <Button variant="contained" color="warning" onClick={() => upgradeDB(2)}>
//             Upgrade DB
//           </Button>
//           <Button variant="contained" color="success" onClick={getTopRow}>
//             Get Top Row
//           </Button>
//           <Button variant="contained" color="info" onClick={createTable}>
//             Create Table (Insert Sample Data)
//           </Button>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default IndexedDBManager;
import React, { useState, useEffect } from "react";
import { Button, Container, Paper, Typography, Box, TextField } from "@mui/material";

const IndexedDBManager = () => {
  const [dbExists, setDbExists] = useState(false);
  const [tableExists, setTableExists] = useState(false);
  const [topRow, setTopRow] = useState(null);
  const [inputData, setInputData] = useState({ name: "", value: "" });

  const initDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("hlthtekdb", 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains("t_org_key")) {
          db.createObjectStore("t_org_key", { keyPath: "id", autoIncrement: true });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  };

  const checkDBAndTableExists = async () => {
    const databases = await indexedDB.databases();
    const exists = databases.some((db) => db.name === "hlthtekdb");
    setDbExists(exists);
    
    if (exists) {
      const request = indexedDB.open("hlthtekdb", 1);
      request.onsuccess = (event) => {
        const db = event.target.result;
        setTableExists(db.objectStoreNames.contains("t_org_key"));
      };
    } else {
      setTableExists(false);
    }
  };

  const upgradeDB = (newVersion) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("hlthtekdb", newVersion);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains("t_org_key")) {
          db.createObjectStore("t_org_key", { keyPath: "id", autoIncrement: true });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  };

  const createTable = async () => {
    const db = await initDB();
    const transaction = db.transaction("t_org_key", "readwrite");
    const store = transaction.objectStore("t_org_key");

    store.add({ name: "Test Org", value: "12345" });
  };

  const insertData = async () => {
    const db = await initDB();
    const transaction = db.transaction("t_org_key", "readwrite");
    const store = transaction.objectStore("t_org_key");

    store.add(inputData);
    setInputData({ name: "", value: "" });
  };

  const getTopRow = async () => {
    const db = await initDB();
    const transaction = db.transaction("t_org_key", "readonly");
    const store = transaction.objectStore("t_org_key");

    return new Promise((resolve, reject) => {
      const request = store.openCursor();
      request.onsuccess = (event) => {
        const cursor = event.target.result;
        setTopRow(cursor ? cursor.value : null);
        resolve(cursor ? cursor.value : null);
      };
      request.onerror = () => reject(request.error);
    });
  };

  useEffect(() => {
    checkDBAndTableExists();
  }, []);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 3, textAlign: "center", marginTop: 5 }}>
        <Typography variant="h5" gutterBottom>
          IndexedDB Manager
        </Typography>
        <Typography variant="body1">
          Database Exists: <strong>{dbExists ? "Yes" : "No"}</strong>
        </Typography>
        <Typography variant="body1">
          Table Exists: <strong>{tableExists ? "Yes" : "No"}</strong>
        </Typography>
        <Typography variant="body1">
          Top Row: {topRow ? JSON.stringify(topRow) : "No Data"}
        </Typography>
        <Box mt={2} display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Name"
            variant="outlined"
            value={inputData.name}
            onChange={(e) => setInputData({ ...inputData, name: e.target.value })}
          />
          <TextField
            label="Value"
            variant="outlined"
            value={inputData.value}
            onChange={(e) => setInputData({ ...inputData, value: e.target.value })}
          />
          <Button variant="contained" color="primary" onClick={initDB}>
            Initialize DB
          </Button>
          <Button variant="contained" color="secondary" onClick={checkDBAndTableExists}>
            Check DB & Table
          </Button>
          <Button variant="contained" color="warning" onClick={() => upgradeDB(2)}>
            Upgrade DB
          </Button>
          <Button variant="contained" color="success" onClick={getTopRow}>
            Get Top Row
          </Button>
          <Button variant="contained" color="info" onClick={createTable}>
            Create Table (Insert Sample Data)
          </Button>
          <Button variant="contained" color="primary" onClick={insertData}>
            Insert Data
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default IndexedDBManager;
